exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-position[data-v-aaedb818]{width:100%;position:absolute;top:-100px}.tabbar[data-v-aaedb818]{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;top:-18px;left:15px}.tabbar-item[data-v-aaedb818]{width:164px;height:50px;background:url(\"/images/judicialService/tabbar-bg.png\") no-repeat 50%;background-size:100% 100%;text-align:center;line-height:50px;padding-right:14px}.tabbar-item .text[data-v-aaedb818]{width:100%;height:100%;display:block;font-size:20px;line-height:50px;font-family:PingFang SC;font-weight:500;color:#290202}.tabbar-item.active .text[data-v-aaedb818]{color:#ec1c1c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aaedb818","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/judicialService/tabbar.vue
// module id = E53S
// module chunks = 67 68 69 70 71 78 79 80 81 180